interface StudentInitialsProps {
  firstName: string;
  lastName: string;
  size?: "sm" | "md" | "lg";
}

export const StudentInitials = ({
  firstName,
  lastName,
  size = "md",
}: StudentInitialsProps) => {
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();

  const sizeClasses = {
    sm: "w-12 h-12 text-sm",
    md: "w-16 h-16 text-lg",
    lg: "w-24 h-24 text-2xl",
  };

  const colors = [
    "#3B82F6",
    "#8B5CF6",
    "#EC4899",
    "#22C55E",
    "#F97316",
    "#EF4444",
    "#6366F1",
    "#06B6D4",
  ];

  // Use first letter of firstName to determine color consistently
  const colorIndex = firstName.charCodeAt(0) % colors.length;

  return (
    <div
      className={`${sizeClasses[size]} ${colors[colorIndex]} rounded-full flex items-center justify-center text-white font-bold`}
    >
      {initials}
    </div>
  );
};
